import { render, staticRenderFns } from "./GroupBuyList.vue?vue&type=template&id=3f967821&scoped=true"
import script from "./GroupBuyList.vue?vue&type=script&lang=js"
export * from "./GroupBuyList.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyList.vue?vue&type=style&index=0&id=3f967821&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f967821",
  null
  
)

export default component.exports